import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CanvasBlock = ({
  title,
  description,
  value,
  onChange,
  onSuggest,
  placeholder,
  maxLength = 500,
  isLoading = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const characterCount = value?.length || 0;
  const isNearLimit = characterCount > maxLength * 0.8;
  const isComplete = characterCount > 50;

  return (
    <div className="h-full flex flex-col bg-card border-2 border-border rounded-lg transition-smooth hover:elevation-md">
      <div className="p-4 border-b border-border bg-muted/30">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
            {title}
          </h3>
          {isComplete && (
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-success/20 flex items-center justify-center">
              <Icon name="Check" size={14} color="var(--color-success)" strokeWidth={2.5} />
            </div>
          )}
        </div>
        <p className="text-xs text-muted-foreground font-caption">
          {description}
        </p>
      </div>
      <div className="flex-1 p-4 flex flex-col">
        <textarea
          value={value}
          onChange={(e) => onChange(e?.target?.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          maxLength={maxLength}
          className={`flex-1 w-full bg-transparent text-sm text-foreground placeholder:text-muted-foreground resize-none focus:outline-none transition-smooth ${
            isFocused ? 'opacity-100' : 'opacity-80'
          }`}
          aria-label={`${title} input field`}
        />

        <div className="mt-3 flex items-center justify-between gap-3">
          <span
            className={`text-xs font-caption transition-smooth ${
              isNearLimit ? 'text-warning' : 'text-muted-foreground'
            }`}
          >
            {characterCount}/{maxLength}
          </span>

          <Button
            variant="ghost"
            size="sm"
            onClick={onSuggest}
            loading={isLoading}
            iconName="Sparkles"
            iconPosition="left"
            iconSize={14}
            className="text-xs"
          >
            Suggest Ideas
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CanvasBlock;